import { AxiosError } from "axios";
import { apiNoAuth, apiWithAuth } from "../authApi";
import { useToasterStore } from "../../store/toaster";
import {
  AuthWalletRequest,
  AuthWalletResponse,
  PutAuthWalletRequest,
  PutAuthWalletResponse,
} from "@/modules/user/types/connect-wallet";

export const postAuthWallet = async (
  payload: AuthWalletRequest
): Promise<AuthWalletResponse | undefined> => {
  try {
    const response = await apiNoAuth.post("/auth/wallet", payload);

    const answer = response.data as AuthWalletResponse;

    return answer;
  } catch (err: unknown) {
    let message = "Unknown error";

    if (err instanceof AxiosError) {
      message =
        (err.response?.data as { error?: string })?.error ?? err.message;
    } else if (err instanceof Error) {
      message = err.message;
    }

    useToasterStore.getState().addToast({
      title: "Error",
      message,
      duration: 5000,
    });

    return undefined;
  }
};

export const postAuthWalletConnect = async (
  payload: AuthWalletRequest
): Promise<unknown> => {
  try {
    const response = await apiWithAuth.post("/auth/wallet/connect", payload);

    const answer = response.data as unknown;

    return answer;
  } catch (err: unknown) {
    let message = "Unknown error";

    if (err instanceof AxiosError) {
      message =
        (err.response?.data as { error?: string })?.error ?? err.message;
    } else if (err instanceof Error) {
      message = err.message;
    }

    useToasterStore.getState().addToast({
      title: "Error",
      message,
      duration: 5000,
    });

    return undefined;
  }
};

export const putAuthWallet = async (
  payload: PutAuthWalletRequest
): Promise<PutAuthWalletResponse | undefined> => {
  try {
    const response = await apiNoAuth.put("/auth/wallet", payload);

    const answer = response.data as PutAuthWalletResponse;

    return answer;
  } catch (err: unknown) {
    let message = "Unknown error";

    if (err instanceof AxiosError) {
      message =
        (err.response?.data as { error?: string })?.error ?? err.message;
    } else if (err instanceof Error) {
      message = err.message;
    }

    useToasterStore.getState().addToast({
      title: "Error",
      message,
      duration: 5000,
    });

    return undefined;
  }
};
